__turbopack_context__.v({
  "appear-slide-left": "MobileMenu-module-scss-module__NHfpVa__appear-slide-left",
  "backButton": "MobileMenu-module-scss-module__NHfpVa__backButton",
  "bounceTwice": "MobileMenu-module-scss-module__NHfpVa__bounceTwice",
  "catLink": "MobileMenu-module-scss-module__NHfpVa__catLink",
  "downArrow": "MobileMenu-module-scss-module__NHfpVa__downArrow",
  "fade-in-bottom": "MobileMenu-module-scss-module__NHfpVa__fade-in-bottom",
  "fade-in-left": "MobileMenu-module-scss-module__NHfpVa__fade-in-left",
  "fade-in-right": "MobileMenu-module-scss-module__NHfpVa__fade-in-right",
  "fadeIn": "MobileMenu-module-scss-module__NHfpVa__fadeIn",
  "image": "MobileMenu-module-scss-module__NHfpVa__image",
  "loader": "MobileMenu-module-scss-module__NHfpVa__loader",
  "menuContainer": "MobileMenu-module-scss-module__NHfpVa__menuContainer",
  "mobileMenu": "MobileMenu-module-scss-module__NHfpVa__mobileMenu",
  "mobileMenu--active": "MobileMenu-module-scss-module__NHfpVa__mobileMenu--active",
  "puff-in-center": "MobileMenu-module-scss-module__NHfpVa__puff-in-center",
  "puff-in-left": "MobileMenu-module-scss-module__NHfpVa__puff-in-left",
  "pulse": "MobileMenu-module-scss-module__NHfpVa__pulse",
  "pulse-contact": "MobileMenu-module-scss-module__NHfpVa__pulse-contact",
  "serviceCategory": "MobileMenu-module-scss-module__NHfpVa__serviceCategory",
  "shake-bottom": "MobileMenu-module-scss-module__NHfpVa__shake-bottom",
  "slide-again": "MobileMenu-module-scss-module__NHfpVa__slide-again",
  "slide-in-right": "MobileMenu-module-scss-module__NHfpVa__slide-in-right",
  "stepContent-entrance": "MobileMenu-module-scss-module__NHfpVa__stepContent-entrance",
  "submenu": "MobileMenu-module-scss-module__NHfpVa__submenu",
});
